import React, { FC } from "react";
import { SkeletonBase } from "@foris/avocado-suite";
import styles from "./dimensionsSearchSkeleton.module.scss";

interface DimensionsSearchSkeletonProps {
  rows?: number;
  columns?: number;
  loading?: boolean;
  showHeader?: boolean;
  showPagination?: boolean;
}

const DimensionsSearchSkeleton: FC<DimensionsSearchSkeletonProps> = ({
  columns = 6,
  rows = 13,
  showHeader = true,
  showPagination = true,
}) => {
  return (
    <div className={styles.cntResultsSkeleton}>
      {showHeader && (
        <div className={styles.cntResultsSkeleton_header}>
          <SkeletonBase maxWidth={182} height={36} radius={4} />
        </div>
      )}

      <div className={styles.cntResultsSkeleton_table}>
        <div className={styles.header}>
          <SkeletonBase height={38} />
        </div>
        {Array.from({ length: rows }).map((_, _index) => (
          <div className={styles.columns} key={_index}>
            {Array.from({ length: columns }).map((_, _indexItem) => (
              <div className={styles.columns_item} key={_indexItem}>
                <SkeletonBase width={"100%"} height={28} />
              </div>
            ))}
          </div>
        ))}
      </div>

      {showPagination && (
        <div className={styles.cntResultsSkeleton_paginationBtn}>
          <SkeletonBase maxWidth={36} height={36} radius={"8px 0 0 8px"} />
          {Array(5)
            .fill([])
            .map((_, index) => {
              return <SkeletonBase key={index} maxWidth={36} height={36} radius={0} />;
            })}
          <SkeletonBase maxWidth={36} height={36} radius={"0 8px 8px 0"} />
        </div>
      )}
    </div>
  );
};

export default DimensionsSearchSkeleton;
